import { render } from "./LeaveAdminArticlesView.vue?vue&type=template&id=8ae9edfa&scoped=true"
import script from "./LeaveAdminArticlesView.vue?vue&type=script&lang=js"
export * from "./LeaveAdminArticlesView.vue?vue&type=script&lang=js"

import "./LeaveAdminArticlesView.vue?vue&type=style&index=0&id=8ae9edfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ae9edfa"]])

export default __exports__